import { render, staticRenderFns } from "./CardDepoimentos.vue?vue&type=template&id=9f9bf98c&scoped=true"
import script from "./CardDepoimentos.vue?vue&type=script&lang=js"
export * from "./CardDepoimentos.vue?vue&type=script&lang=js"
import style0 from "./CardDepoimentos.vue?vue&type=style&index=0&id=9f9bf98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9bf98c",
  null
  
)

export default component.exports